exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".articleAuthorContainers\n{\n    height: 30vh;\n    position: relative;\n}\n\n.articlePageAuthorItem\n{\n    height: 30vh;\n    width: 24%;\n    background-size: cover;\n    background-position: center;\n/*    background-image: linear-gradient(rgba(0, 0, 0, 0.9), rgba(0, 0, 0, 0.9));*/\n    position: relative;\n    float: left;\n    margin-right: 1%;\n    margin-bottom: 1%;\n}\n\n.articlePageAuthorItem--Text\n{\n    background-image: -webkit-gradient(linear, left top, left bottom, from(rgba(0, 0, 0, 0.9)), to(rgba(0, 0, 0, 0.9)));\n    background-image: linear-gradient(rgba(0, 0, 0, 0.9), rgba(0, 0, 0, 0.9));\n    color: rgb(255,255,255);\n    font-size: 14pt;\n    text-align: center;\n    padding-top: 3%;\n    padding-bottom: 3%;\n    width: 100%;\n    bottom: 0;\n    position: absolute;\n}\n\n#articleAuthorImage--1\n{\n    background-image: url('/assets/paulHeadshot.jpg');\n}\n\n#articleAuthorImage--2\n{\n    background-image: url('/assets/JustinMalave.jpg');\n}\n\n.articlePageContent\n{\n    font-size: 13pt;\n    margin-bottom: 3%;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ppeters/filmCritClient/src/app/components/authorSection/authorSection.component.css
// module id = ../../../../../src/app/components/authorSection/authorSection.component.css
// module chunks = main